<template>
  <div class="jobs-profile__card">
    <div class="jobs-profile__title-box position-relative">
      <slot name="title"></slot>
      <MenuPopupWrapper
        iconClass="margin-right-8 color-complementary-200 cursor--pointer"
        menuClass="left-0 top-10 z-index-1 padding-top-24"
        :items="menuItems"
        :permissions="permissions"
        :showMenu="isShowMenu"
        :rowItem="null"
        @click="handleOpenMenu"
        @close="handleCloseMenu"
      />
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script>
import MenuPopupWrapper from "@/components/re-design/modal/MenuPopupWrapper.vue";
import { toRefs } from "vue";
export default {
  components: { MenuPopupWrapper },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    isShowMenu: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { permissions, menuItems, isShowMenu } = toRefs(props);

    const handleOpenMenu = (item) => {
      emit("handleOpenMenu", item);
    };
    const handleCloseMenu = (item) => {
      emit("handleCloseMenu", item);
    };

    // return data to be used in template
    return {
      permissions,
      menuItems,
      isShowMenu,
      handleOpenMenu,
      handleCloseMenu,
    };
  },
};
</script>
